<template>
  <nav class="navbar navbar-dark sticky-top bg-primary">
    <div class="container-fluid">
      <div class="navbar-header">
        <span v-if="sysco == 2">
          <img src="/src/assets/ReynaersLogo.jpg" style="width: 10%" class="img mr-2" />
        </span>
        <span v-if="sysco == 4">
          <img src="/src/assets/VBHLogo.png" style="width: 10%" class="img mr-2" />
        </span>
        <span v-if="sysco == 5">
          <img src="/src/assets/AlukLogo.png" style="width: 20%" class="img mr-2" />
        </span>
        <span v-if="sysco == 7">
          <img src="/src/assets/SapaLogo.jpg" style="width: 15%" class="img mr-2" />
        </span>
        <span v-if="sysco == 8">
          <img src="/src/assets/TitonLogo.svg" style="width: 25%" class="img mr-2 pb-2" />
        </span>
        <span v-if="sysco == 9">
          <img src="/src/assets/AliplastLogo.png" style="width: 15%" class="img mr-2 pb-2" />
        </span>
        <a class="navbar-brand" href="/">
          Chrono Logic
          <strong>Online</strong>
          <small>{{version}}</small>
        </a>
      </div>
      <ul class="nav navbar-nav navbar-right" style="color:white">
        <li v-if="isAuthenticated">
          <button type="button" class="btn btn-outline-light btn-sm mr-3" @click="logout">Logout</button>
          {{fullName}}
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["sysco"],
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    fullName() {
      return `${this.$store.getters.getAuth.firstName} ${this.$store.getters.getAuth.lastName}`;
    },
    version() {
      return this.$store.getters.getVersion;
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/intro/AppHeader.vue